import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=479fab2c&scoped=true"
import script from "./Galleries.vue?vue&type=script&lang=js"
export * from "./Galleries.vue?vue&type=script&lang=js"
import style0 from "./Galleries.vue?vue&type=style&index=0&id=479fab2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479fab2c",
  null
  
)

export default component.exports